(() => {
  'use strict';

  const maxWaitMs = 10000;
  const bundleSelector = '#amp-volume-discount-bundles-embed-section';
  const productAtcSelector = 'form[action*="/cart/add"] .product-form--atc';
  let observer = null;
  let stopTimer = null;
  let positionScheduled = false;

  const stopWatching = () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    if (stopTimer) {
      clearTimeout(stopTimer);
      stopTimer = null;
    }
  };

  const positionBundleWidget = () => {
    const bundleContainer = document.querySelector(bundleSelector);
    const productAtc = document.querySelector(productAtcSelector);
    const productForm = productAtc && productAtc.closest('form[action*="/cart/add"]');

    if (!bundleContainer || !productForm || !productAtc) {
      return false;
    }

    productForm.insertBefore(bundleContainer, productAtc);
    bundleContainer.style.marginTop = '10px';
    stopWatching();
    return true;
  };

  const schedulePosition = () => {
    if (positionScheduled) return;
    positionScheduled = true;

    requestAnimationFrame(() => {
      positionScheduled = false;
      positionBundleWidget();
    });
  };

  const handleMutations = (mutations) => {
    const bundleWasAdded = mutations.some((mutation) => {
      return Array.from(mutation.addedNodes).some((node) => {
        const isBundle = node.matches && node.matches(bundleSelector);
        const containsBundle = node.querySelector && node.querySelector(bundleSelector);
        return isBundle || containsBundle;
      });
    });

    if (bundleWasAdded) schedulePosition();
  };

  const startWatching = () => {
    observer = new MutationObserver(handleMutations);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    if (positionBundleWidget()) return;

    stopTimer = setTimeout(stopWatching, maxWaitMs);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWatching, { once: true });
  } else {
    startWatching();
  }
})();
